
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRadarTargetTrackedFilled as ObiRadarTargetTrackedFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-radar-target-tracked-filled.js';
 
 
 

 
 export const ObiRadarTargetTrackedFilled = createComponent({
   react: React,
   tagName: 'obi-radar-target-tracked-filled',
   elementClass: ObiRadarTargetTrackedFilledElement,
   events: {
     
   }
  });
 
 